import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getList } from '../../api/taskClock';
import { startClockByTask, stopClockByTask } from '../../api/taskClock';
import { path } from 'ramda';
import Preloader from '../../common/Preloader';
import Breadcrumbs from "../../common/Breadcrumbs";

export class TaskClock extends Component {

  constructor(props) {
    super(props);
    this.createProjects = this.createProjects.bind(this);
    this.createTasks = this.createTasks.bind(this);
  }

  componentWillMount() {
    const taskId = path([ 'match', 'params', 'id' ], this.props);
    this.props.nestedList(taskId);
  }

  createTasks(item) {
    const tasksContainer = [];

    if ( !item || !item.tasks ) {
      return null;
    }

    for (let i = 0; i < item.tasks.length; i++) {
      const itemId = item.id;
      const taskItem = item.tasks[ i ];
      const startedTime = path([ 'clock', 'started' ], taskItem);
      const stoppedTime = path([ 'clock', 'stopped' ], taskItem);
      const isStarted = startedTime && startedTime != '0000-00-00 00:00:00';
      const isStopped = stoppedTime && stoppedTime != '0000-00-00 00:00:00';
      const duration = path([ 'clock', 'duration' ], taskItem);
      const start = function() {this.props.startClock({ "item_id": itemId, "task_id": taskItem.id })}.bind(this);
      const stop = function() {this.props.stopClock({ "item_id": itemId, "task_id": taskItem.id })}.bind(this);
      let mainPartOfTask;
      if ( taskItem && taskItem.clock ) {
        mainPartOfTask =
          <div>
            {(!isStarted || (isStarted && isStopped)) && <i onClick={start} className="fa fa-play-circle-o pull-left"
                                                            style={{ fontSize: '22px', cursor: 'pointer' }}/>}
            {(isStarted && !isStopped) && <i onClick={stop} className="fa fa-stop-circle-o pull-left"
                                             style={{ fontSize: '22px', cursor: 'pointer' }}/>}
            {isStopped &&
            <span style={{ margin: '0px 5px' }} className="pull-left"> <b>End time:</b> {stoppedTime} </span>}
            {isStarted &&
            <span style={{ margin: '0px 5px' }} className="pull-left"> <b>Start time:</b> {startedTime} </span>}
            {duration && <span style={{ margin: '0px 5px' }} className="pull-left"> <b>Duration:</b> {duration} </span>}
          </div>;
      }
      else {
        mainPartOfTask = <div>
          <i onClick={start} className="fa fa-play-circle-o pull-left"
             style={{ fontSize: '22px', cursor: 'pointer' }}/>
        </div>
      }
      tasksContainer.push(
        <div className="alert alert-success" style={{ height: '65px' }}>
          <div>
            <b>{taskItem.name}</b>
          </div>
          {mainPartOfTask}
        </div>
      );
    }

    return tasksContainer;
  }

  createProjects() {
    const projects = path([ 'taskClock', 'list' ], this.props);
    const projectsContainer = [];

    if ( !projects ) {
      return null;
    }

    for (let i = 0; i < projects.length; i++) {
      const item = projects[ i ];
      projectsContainer.push(
        <div className="card rounded" style={{ marginTop: '15px' }}>
          <div className="card-header rounded-top">
            <b>{item.name}</b>
          </div>
          <div className="card-block">
            {this.createTasks(item)}
          </div>
        </div>
      );
    }

    return projectsContainer;
  }

  render() {
    const id = path([ 'match', 'params', 'id' ], this.props);
    const projects = this.createProjects();
    let preloader = null;
    if ( projects === null ) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        {id &&
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/task/' + id, icon: 'library_books', name: 'Task' },
          { icon: 'alarm', name: 'Task Clock' },
        ]}/>
        }
        <div className="card rounded">
          <div className="card-header rounded-top">
            Work Order Clocks
          </div>
          <div className="card-block">
            {preloader}
            {projects}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    nestedList: (taskId) => {
      // TODO: Run action: START_PRELOADER
      getList(taskId)(dispatch);
    },
    startClock: (data) => {
      startClockByTask(data)(dispatch);
    },
    stopClock: (data) => {
      stopClockByTask(data)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskClock);



// WEBPACK FOOTER //
// ./src/containers/TaskClock/index.js